import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import MapPage from "./pages/mapLayout/map.page";
import Page404 from "./pages/404/404.component";
import { Switch, Route } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import "./index.css";

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate persistor={persistor}>
        <Switch>
          <Route exact path="/" component={MapPage} />
          <Route component={Page404} />
        </Switch>
      </PersistGate>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
serviceWorker.register();
